<template>
  <!-- 外部ユーザー管理 -->
  <div id="ExternalUserControlSearch">
    <div id="container">
      <div class="labelTitle lable">外部ユーザー管理</div>
      <externalUserSearch v-bind:from="'control'" v-bind:preSearchConditions="searchConditions"/>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/master/MasterMaintenanceBar";
import userNaviBar from "@/components/mock/philips/master/user/UserNavi";
import externalUserSearchTemplate from "@/components/mock/philips/master/user/ExternalUserSearchContent";
export default {
  name: "ExternalUserControlSearch",
  methods: {
  },
  data() {
    var searchConditions = this.$route.params["searchConditions"];
    return {
      searchConditions:searchConditions
    };
  },
  filters: {},
  components: {
    masterNavi: naviBar,
    userNavi: userNaviBar,
    externalUserSearch: externalUserSearchTemplate
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
.tag {
  width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/user/ExternalUserControlSearch.vue